export default {
  methods: {
    getSpaceSymbol(name) {
      return name.charAt(0);
    },
  },
};
